export default {
  create_collection: 'Add to Learning Path',
  edit_collection: 'Update learning path',
  collection_label: 'Name of the learning path',
  collection_input_error: 'Enter a name for the learning path',
  collection_select_error: 'Please select a learning path',
  update_generic: 'Update',
  video_title: 'Video title',

  collection_desc: 'Description of the learning path',
  collection_desc_error: 'Enter a description for the learning path',

  video_desc_error: 'Enter a description for the video',

  collection_min_err: `Please select a video`,
  create_video: {
    title: 'Create new video',
    recording: {
      title: 'Create screen recorded walkthrough video',
      description:
        ' Record your screen, later edit or add audio by using text to speech conversion or your own voice.'
    },
    insta_recording: {
      title: 'Create instant screen recorded video',
      description:
        'Record your screen and share it with your users in an instant'
    },
    presentation: {
      title: 'Presentation style training video',
      description:
        'Upload your PDF presentation, later edit or add audio by using text to speech conversion or your own voice.'
    },
    manual_upload: {
      title: 'Upload video',
      description: 'Upload your existing training video.'
    },
    description:
      'Just some more information first and we’ll start creating the video',
    upload_description:
      'Just some more information, before uploading the video',
    upload_video: 'Upload your mp4 video',
    upload_video_desc:
      'Video should be in mp4 format and size less than 20MB. Please contact us, if you wish to upload a video with size greater than 20MB.',
    input_label: 'Video name',
    input_placeholder: 'Give an easy name to remember',
    invalid_input: 'Please enter a name',
    url_label: 'Record from URL',
    url_placeholder: 'https://yourwebsite.com',
    invalid_url: 'Please enter an url to proceed',
    invalid_url_format: 'Please enter a valid url',
    upload_pdf: 'Upload a PDF or an image',
    create: "Let's Create",
    upload: 'Upload and Publish',
    note:
      'On clicking "Create" you will be redirected to the corresponding url where you can start your recording using the "Trainn" extension.'
  },
  collection: {
    new: 'Create new learning path',
    existing: 'Add to existing learning path',
    add_description: 'Add description for your learning path',
    add_thumbnail_image: 'Add thumnail image',
    download_thumbnail:
      "You can download thumbnail images for free, from this opensource website <a href='https://www.manypixels.co/gallery' target='_blank'>Manypixels</a>.",
    delete: {
      title: 'Are you sure you want to delete this learning path?',
      description:
        'On deleting, this learning path will be deleted forever. All the links associated with this learning path will not be available anymore.',
      delete_btn: 'Yes, Delete it!',
      cancel: "No, don't delete it"
    },
    description:
      'Trainn offers a feature where you can group a set of videos and share it with your customers via an unique URL.'
  },
  video: {
    add_description: 'Add description for your video'
  },
  browser_refresh: 'Kindly refresh the page if already installed!',
  guide:
    'Goto the corresponding url and click on the trainn extension in the upper right of your browser to get started.',
  insta_guide:
    'Goto the corresponding url and click on the trainn insta extension in the upper right of your browser to get started.'
};
